import { isStorageAvailable, StorageWrapper } from "utils/infrastructure/storage-util"
import { Value } from "utils/helpers"

const DEVICE_KEY = "id"
const DEVICE_STATE_KEY = "on"

type Keys = typeof DEVICE_KEY | typeof DEVICE_STATE_KEY
type DevicesData = Record<Keys, string | number | undefined>

const defaultData = {
    [DEVICE_KEY]: undefined,
    [DEVICE_STATE_KEY]: 1,
}

export class SelectedDevicesStorage {
    private static instance: SelectedDevicesStorage
    private storage: StorageWrapper | undefined
    private _data: DevicesData = defaultData

    constructor(private settingsStorageName: string) {
        this.storage = isStorageAvailable ? new StorageWrapper(window.localStorage) : undefined
    }

    get deviceId(): string {
        return new Value(this.getValue(DEVICE_KEY)).toString()
    }

    set deviceId(guid: number | string) {
        this.saveValue(DEVICE_KEY, guid)
    }

    get state(): boolean {
        return new Value(this.getValue(DEVICE_STATE_KEY)).toBoolean(true)
    }

    set state(on: boolean) {
        this.saveValue(DEVICE_STATE_KEY, String(on ? 1 : 0))
    }

    private get data() {
        if (this.storage) {
            if (this._data) {
                this._data = this.storage.getObject(this.settingsStorageName) as DevicesData
            }
            return this._data
        }
    }

    private saveValue(key: Keys, value: number | string) {
        if (this.storage) {
            const old = this.data
            this._data = { ...defaultData, ...old, [key]: value }
            this.storage?.storeObject(this.settingsStorageName, this._data)
        }
    }

    private getValue(key: Keys) {
        if (this.storage) {
            return this.data ? this.data[key] : undefined
        }
    }
}
